import { NavLink } from "react-router-dom";
import { apiUrlImg } from "../../../../api/api";
import { useEffect } from "react";

export const InfromacionCompleta = ({ leadDetails }) => {
    // Configuración de campos en bloques de tres
    const clientDetails = [
        [
            { label: "Nombre cliente:", value: leadDetails.nombre_cliente || "--" },
            { label: "Nombre empresa:", value: leadDetails.nombre_empresa || "--" },
            { label: "Correo Cliente:", value: leadDetails.correo_cleinte || "--" },
        ],
        [
            { label: "Número de teléfono:", value: leadDetails.telefono_cliente || "--" },
            { label: "Tipo Cliente:", value: leadDetails.tipo_cliente_cliente || "--" },
            { label: "Crédito cliente:", value: leadDetails.credito_cliente || "--" },
        ],
        [
            { label: "Monto crédito:", value: leadDetails.Monto_credito || "--" },
            { label: "Ejecutivo:", value: leadDetails.ejecutivos_name || "--" },
            { label: "Estado Cliente:", value: leadDetails.esatdo_cliente === 1 ? "Activo" : "Inactivo" || "--" },
        ],

        [
            { label: "Hijos:", value: leadDetails.hijos || "--" },
            { label: "Notas Importantes:", value: leadDetails.notasImportantes || "--" },
            { label: "Puesto:", value: leadDetails.puesto || "--" },
        ],
    ];
    const empresa = [
        [
            { label: "Nombre empresa:", value: leadDetails.nombre_empresa || "--" },
            { label: "Razón social:", value: leadDetails.razon_social || "--" },
            { label: "Cédula jurídica:", value: leadDetails.cedula_juridica || "--" },
        ],
        [
            { label: "Página web:", value: leadDetails.pagina_web || "--" },
            { label: "Teléfono:", value: leadDetails.telefono || "--" },
            { label: "País:", value: leadDetails.pais || "--" },
        ],
        [
            { label: "Dirección física:", value: leadDetails.direccion_fisica || "--" },
            { label: "Industria:", value: leadDetails.industria || "--" },
            { label: "Tipo de empresa:", value: leadDetails.tipo_cliente_cliente || "--" },
        ],
        [
            { label: "Tiene crédito:", value: leadDetails.tiene_credito || "--" },
            { label: "Notas importantes:", value: leadDetails.notasImportantes_cliente_cliente || "--" },
        ],
    ];
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await fetch(`${apiUrlImg}${leadDetails.logoEmpresa}`);
                if (response.ok) {
                    const imageBlob = await response.blob();
                    const imageUrl = URL.createObjectURL(imageBlob);
                    document.querySelector("#logoempresas").src = imageUrl;
                } else {
                    console.error("Failed to load image");
                }
            } catch (error) {
                console.error("Error fetching logo:", error);
            }
        };
        if (leadDetails.logoEmpresa) fetchLogo();
    }, [leadDetails.logoEmpresa]);
    return (
        <>
            {" "}
            <div className="card">
                <div className="card-header">
                    <h5>Informacion Completa</h5>
                </div>
                <div className="card-body">
                    <p className="mb-0">Desglose de infromacion relacionada al cliente</p>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>Rsemun de Informacion</h5>
                </div>
                <div className="card-body">
                    <ul className="list-group list-group-flush">
                        {clientDetails.map((section, index) => (
                            <li className="list-group-item px-0" key={`client-section-${index}`}>
                                <div className="row">
                                    {section.map((field, idx) => (
                                        <div className="col-md-4" key={`client-field-${idx}`}>
                                            <p className="mb-1 text-muted">{field.label}</p>
                                            <p className="mb-0">{field.value}</p>
                                        </div>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>
                        Empresa{" "}
                        <NavLink to={`/empresas/perfil?data=${leadDetails.idEmpresaRelacion}`} className="pc-link active">
                            <span className="pc-micon">
                                <i className="ti ti-search"></i>
                            </span>
                            <span className="pc-mtext">Ver perfil de empresa</span>
                        </NavLink>
                    </h5>
                </div>
                <div className="card-body">
                    <h5>Infirmacion Empresa</h5>
                    <div className="chat-avtar d-inline-flex mx-auto">
                        <img id="logoempresas" alt="User image" className="img-fluid img-thumbnail" style={{ width: "200px", height: "auto", color: "transparent" }} />
                        <i className="chat-badge bg-success me-2 mb-2"></i>
                    </div>
                    <ul className="list-group list-group-flush">
                        {empresa.map((section, index) => (
                            <li className="list-group-item px-0" key={`client-section-${index}`}>
                                <div className="row">
                                    {section.map((field, idx) => (
                                        <div className="col-md-4" key={`client-field-${idx}`}>
                                            <p className="mb-1 text-muted">{field.label}</p>
                                            <p className="mb-0">{field.value}</p>
                                        </div>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};
